<template>
    <div>
        <el-card>
            <el-form :inline="true"
                     :model="formInline"
                     ref="formInline"
                     class="demo-form-inline"
            >
                <el-form-item label="诊断分型"

                              prop="zhenduanfenxing">
                    <el-cascader :options="zhenduanfenxing_list"
                                 v-model="formInline.zhenduanfenxing"
                                 :props="{ checkStrictly: true }"
                                 :style="senior ? 'width: 330px': 'width:200px'">
                    </el-cascader>
                </el-form-item>
                <el-form-item>
                    <el-date-picker v-model="formInline.daterange"
                                    style="float: right; padding: 3px 10px"
                                    type="daterange"
                                    value-format="yyyy-MM-dd"
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>
                <el-row>
                    <el-form-item label="审核状态"
                    >
                        <el-select v-model="formInline.status" placeholder="请选择" style="width:690px" clearable>
                            <el-option
                                    v-for="item in options"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-row>
                <el-form-item v-if="!senior">
                    <el-button @click="onSubmit()"
                               type="primary">查询
                    </el-button>
                    <el-button @click="onReset">重置</el-button>
                    <el-button @click="hLower" :class="senior  ? 'el-icon-arrow-up' : 'el-icon-arrow-down'">
                        高级搜索
                    </el-button>
                </el-form-item>
                <el-row v-for="(item,index) in formInline.powerAttrList" :key="index" class="demo-form"
                        :style="index===formInline.powerAttrList.length-1?'margin-left: 15px;':''">
                    <el-form-item
                            v-if='index==0 && formInline.zhenduanfenxing.length==0'
                            style="width:100px"
                    >
                        <el-select placeholder="" v-model="item.condition"
                                   disabled
                        >
                            <el-option label="并且" value="AND"></el-option>
                            <el-option label="或者" value="OR"></el-option>
                            <el-option label="不含" value="NOT"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item
                            v-else
                            style="width:100px"
                            :prop="'powerAttrList.' + index + '.condition'"
                            :rules="[{ required: true, message: '不能为空',trigger: 'change'}]">
                        <el-select placeholder="" v-model="item.condition">
                            <el-option label="并且" value="AND"></el-option>
                            <el-option label="或者" value="OR"></el-option>
                            <el-option label="不含" value="NOT"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item
                            style="width:140px"
                            :prop="index != 0?'powerAttrList.' + index + '.field':''"
                            :rules="[{ required: true, message: '不能为空',trigger: 'change'}]"
                    >
                        <el-select placeholder="字段" v-model="item.field" @change="handleValue(index)">
                            <el-option
                                    v-for="tem in jibenxinxi"
                                    :key="tem.value"
                                    :label="tem.label"
                                    :value="tem.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item v-if="item.field == 'nianling'">
                        <el-select placeholder="" v-model="item.symbol" style="width:100px">
                            <el-option label="等于" value="="></el-option>
                            <el-option label="大于" value=">"></el-option>
                            <el-option label="小于" value="<"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item
                            :prop="index != 0?'powerAttrList.' + index + '.value':''" class="xiala"
                            :rules="[{ required: true, message: '不能为空',trigger: 'change'}]">
                        <el-select placeholder="性别" style="width: 500px;"
                                   v-model="item.value" v-if="item.field=='xingbie'">
                            <el-option label="男" value="男"></el-option>
                            <el-option label="女" value="女"></el-option>
                        </el-select>
                        <el-date-picker v-model="item.value"
                                        v-else-if="item.field=='diag_date'"
                                        type="daterange"
                                        value-format="yyyy-MM-dd"
                                        range-separator="至"
                                        start-placeholder="开始日期"
                                        end-placeholder="结束日期">
                        </el-date-picker>
                        <el-select placeholder="婚姻状况" style="width:500px"
                                   v-model="item.value" v-else-if="item.field=='hunyin'">
                            <el-option label="已婚" value="已婚"></el-option>
                            <el-option label="未婚" value="未婚"></el-option>
                            <el-option label="离异" value="离异"></el-option>
                            <el-option label="丧偶" value="丧偶"></el-option>
                        </el-select>
                        <el-select placeholder="多源共享数据分类" style="width:500px"
                                   v-model="item.value" v-else-if="item.field=='status_tag'">
                            <el-option label="待随访（第一批）" value="待随访（第一批）"></el-option>
                            <el-option label="待随访（第一批）*" value="待随访（第一批）*"></el-option>
                            <el-option label="待随访（第二批）" value="待随访（第二批）"></el-option>
                            <el-option label="死亡(共享数据)" value="死亡(共享数据)"></el-option>
                            <el-option label="死亡(自主上报)" value="死亡(自主上报)"></el-option>
                            <el-option label="存活，已随访" value="存活，已随访"></el-option>
                            <el-option label="失访" value="失访"></el-option>
                        </el-select>
                        <el-select placeholder="诊断分类" style="width:500px"
                                   v-model="item.value" v-else-if="item.field=='alfenlei'">
                            <el-option label="初发急性白血病" value="初发急性白血病"></el-option>
                            <el-option label="治疗相关急性白血病" value="治疗相关急性白血病"></el-option>
                            <el-option label="伴多系病态造血急性髓细胞白血病" value="伴多系病态造血急性髓细胞白血病"></el-option>
                        </el-select>
                        <el-select v-else-if="item.field == 'weiwanzhengshuju'" style="width:500px"
                                   v-model="item.value">
                            <el-option v-for="item in sectionlist" :key="item.value" :label="item.label"
                                       :value="item.value">
                            </el-option>
                        </el-select>
                        <el-select v-else-if="item.field == 'is_image'" style="width:500px"
                                   v-model="item.value">
                            <el-option label="有" :value="1"></el-option>
                            <el-option label="无" :value="0"></el-option>
                        </el-select>
                        <el-select placeholder="名族" style="width:500px"
                                   v-model="item.value" v-else-if="item.field == 'minzu'">
                            <el-option v-for="item in minzu" :key="item.value" :label="item.label"
                                       :value="item.value">
                            </el-option>
                        </el-select>
                        <el-select placeholder="状态" style="width:500px"
                                   v-model="item.value" v-else-if="item.field == 'zhuangtai'">
                            <el-option v-for="item in zhuangtai" :key="item.value" :label="item.label"
                                       :value="item.value">
                            </el-option>
                        </el-select>
                        <el-select placeholder="治疗方案" style="width:500px"
                                   v-model="item.value" v-else-if="item.field == 'zhiliaoxinxi'">
                            <el-option v-for="item in zhiliaoxinxi" :label="item.label" :value="item.value"
                                       :key="item.value">
                            </el-option>
                        </el-select>
                        <el-cascader style="width:500px" v-model="item.value" :options="zhuanguifeiyong" filterable
                                     v-else-if="item.field == 'zhuanguifeiyong'">
                        </el-cascader>
                        <el-cascader style="width:500px" v-model="item.value" :options="xibaoyichuan" filterable
                                     v-else-if="item.field == 'xibaoyichuan'">
                        </el-cascader>
                        <el-cascader style="width:390px" v-model="item.value" :options="fenzibiaozhi" filterable
                                     v-else-if="item.field == 'fenzibiaozhi'">
                        </el-cascader>
                        <el-cascader v-model="item.value" :options="mianyibiaoxing" filterable
                                     v-else-if="item.field == 'mianyibiaoxing'" style="width:280px">
                        </el-cascader>
                        <el-cascader v-model="item.value" :options="city" filterable v-else-if="item.field=='huji'"
                                     style="width:500px">
                        </el-cascader>
                        <el-cascader v-model="item.value" :options="linchuangxinxi" filterable
                                     v-else-if="item.field == 'linchuangxinxi'" style="width:280px">
                        </el-cascader>
                        <el-cascader :options="zhenduanfenxing_list" style="width:500px"
                                     v-model="item.value" v-else-if="item.field =='zhenduanfenxing'"
                        >
                        </el-cascader>
                        <el-input v-model="item.value" style="width:390px" placeholder="请输入"
                                  v-else-if="item.field=='nianling'"></el-input>
                        <el-input v-model="item.value" style="width:500px" placeholder="请输入" v-else></el-input>
                    </el-form-item>
                    <el-form-item v-if="item.field == 'fenzibiaozhi'">
                        <el-select placeholder="" v-model="item.inputvalue" style="width:100px">
                            <el-option label="阴性" value="阴性"></el-option>
                            <el-option label="阳性" value="阳性"></el-option>
                            <el-option label="未作" value="未作"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item v-if="item.field == 'linchuangxinxi' || item.field =='mianyibiaoxing'">
                        <el-select placeholder="" v-model="item.symbol" style="width:100px">
                            <el-option label="等于" value="="></el-option>
                            <el-option label="大于" value=">"></el-option>
                            <el-option label="小于" value="<"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item v-if="item.field == 'linchuangxinxi' || item.field =='mianyibiaoxing'">
                        <el-input v-model="item.inputvalue" style="width:100px" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button v-if="formInline.powerAttrList.length > 1" @click="removeRow(index)" type="text"
                                   style="font-size:20px;padding:5px 0px;">
                            <i class="el-icon-remove-outline"></i>
                        </el-button>
                        <el-button v-if="index===formInline.powerAttrList.length-1"
                                   @click="addRow"
                                   type="text"
                                   style="font-size:20px;padding:5px 0px;">
                            <i class="el-icon-circle-plus-outline"></i>
                        </el-button>
                    </el-form-item>
                    <el-form-item v-if="index===formInline.powerAttrList.length-1" style="position: absolute">
                        <el-button @click="onSubmit()"
                                   type="primary">查询
                        </el-button>
                        <el-button @click="onReset">重置</el-button>
                    </el-form-item>
                </el-row>
                <el-row style="text-align: left;">
                    <el-form-item>
                        <!--                        <el-button @click="dialogVisible = true" :disabled='setmodel' type="primary">添加数据集</el-button>-->
                        <!--                        <el-button @click="applyModel = true" :disabled='but_disabled' type="primary">申请下载</el-button>-->
                        <el-button @click="handelBatch" type="primary"
                                   v-if="groups=='1' || groups=='2' || groups=='4' || is_admin">批量审核
                        </el-button>
                        <el-button @click="handelBatchQuan" type="primary"
                                   v-if="is_admin">批量设置权限
                        </el-button>
                    </el-form-item>
                    <el-form-item class="dynamicTags">
                        <el-radio-group @change="handClick" v-model="tag">
                            <el-radio v-for="(item, index) in dynamicTags" :key="item.pk" border :label="item.pk">
                                {{ item.name }}
                                <span @click="handleClose(item.pk,index)"><i class="el-icon-close"></i></span>
                            </el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-row>
            </el-form>
            <el-table :data="tableData"
                      v-loading="loading"
                      stripe
                      class="table"
                      ref="multipleTable"
                      @selection-change="handleSelectionChange"
                      @sort-change="handleSortChange"
                      :header-cell-class-name="handleHeadAddClass"
                      style="width: 100%">
                <el-table-column
                        type="selection"
                        :selectable='checkboxT'
                        v-if="groups=='1' || groups=='2' || groups=='4' || is_admin"
                        width="55">
                </el-table-column>
                <el-table-column type="index"
                                 label="序号"
                                 header-align="center"
                                 width="70"
                                 align="center">
                    <template slot-scope="scope">
                        <span>{{ (currentPage - 1) * pageSize + scope.$index + 1 }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        label="ID"
                        width="70">
                    <template slot-scope="scope">
                        <el-button @click="handlepk(scope.row)"
                                   size="small"
                                   type="text">{{ scope.row.pk }}
                        </el-button>
                    </template>
                </el-table-column>
                <el-table-column label="生存状态" width="160" prop="sort" align="center" sortable="custom"
                                 show-overflow-tooltip>
                    <template slot-scope="scope" class="update">
                            <el-tag v-if="scope.row.shengcunzhuangtaitag=='suifanggengxin'" class="red">
                                <span>随访待更新</span>
                            </el-tag>
                            <el-tag v-else-if="scope.row.shengcunzhuangtaitag=='siwang'" class="primary">
                                <span>{{ scope.row.bingli }}死亡</span>
                            </el-tag>
                            <el-tag v-else-if="scope.row.shengcunzhuangtaitag=='cunhuo'" class="infos">
                                <span>{{ scope.row.bingli }}存活</span>
                            </el-tag>
                            <el-tag v-else-if="scope.row.shengcunzhuangtaitag=='fangqi'" class="info">
                                <span>{{ scope.row.bingli }}放弃</span>
                            </el-tag>
                            <el-tag v-else class="info">
                                <span>{{ scope.row.bingli }}失访</span>
                            </el-tag>
                    </template>
                </el-table-column>
                <!--                <el-table-column prop="status"-->
                <!--                                 label="审核状态"-->
                <!--                                 width="120">-->
                <!--                    <template slot-scope="scope" class="update">-->
                <!--                        <el-tag v-if="scope.row.status=='0'" type="danger">{{ scope.row.statusName }}</el-tag>-->
                <!--                        <el-tag v-else-if="scope.row.status=='1'" type="success">{{ scope.row.statusName }}</el-tag>-->
                <!--                        <el-tag v-else-if="scope.row.status=='2'" type="warning">{{ scope.row.statusName }}</el-tag>-->
                <!--                        <el-tag v-else type="info">{{ scope.row.statusName }}</el-tag>-->
                <!--                    </template>-->
                <!--                </el-table-column>-->
                <!--                <el-table-column prop="opinion"-->
                <!--                                 label="审批意见"-->
                <!--                                 show-overflow-tooltip-->
                <!--                                 width="100">-->
                <!--                    <template slot-scope="scope">-->
                <!--                        <div v-if="groups != '0' || is_admin">-->
                <!--                            <el-button @click="handleopinion(scope.row)"-->
                <!--                                       size="small"-->
                <!--                                       v-if="scope.row.opinion"-->
                <!--                                       type="text">{{ scope.row.opinion }}-->
                <!--                            </el-button>-->
                <!--                            <el-button @click="handleopinion(scope.row)"-->
                <!--                                       size="small"-->
                <!--                                       v-else-->
                <!--                                       type="text">无-->
                <!--                            </el-button>-->
                <!--                        </div>-->
                <!--                        <div v-else>-->
                <!--                            {{ scope.row.opinion }}-->
                <!--                        </div>-->
                <!--                    </template>-->
                <!--                </el-table-column>-->
                <!--                <el-table-column prop="shengcunzhuangtai"-->
                <!--                                 label="状态"-->
                <!--                                 width="110"-->
                <!--                >-->
                <!--                    <template slot-scope="scope" class="update">-->
                <!--                        <el-tag v-if="scope.row.shengcunzhuangtaitag=='suifanggengxin'" class="red">-->
                <!--                            <span>随访待更新</span>-->
                <!--                        </el-tag>-->
                <!--                        <el-tag v-else-if="scope.row.shengcunzhuangtaitag=='siwang'" class="primary">-->
                <!--                            <span>{{ scope.row.bingli }}死亡</span>-->
                <!--                        </el-tag>-->
                <!--                        <el-tag v-else-if="scope.row.shengcunzhuangtaitag=='cunhuo'" class="info">-->
                <!--                            <span>{{ scope.row.bingli }}存活</span>-->
                <!--                        </el-tag>-->
                <!--                        <el-tag v-else-if="scope.row.shengcunzhuangtaitag=='fangqi'" class="info">-->
                <!--                            <span>{{ scope.row.bingli }}放弃</span>-->
                <!--                        </el-tag>-->
                <!--                        <el-tag v-else class="info">-->
                <!--                            <span>{{ scope.row.bingli }}失访</span>-->
                <!--                        </el-tag>-->
                <!--                    </template>-->
                <!--                </el-table-column>-->
                <el-table-column prop="xingming"
                                 label="患者姓名"
                                 width="90">
                </el-table-column>
                <el-table-column prop="nianling"
                                 label="患者年龄"
                                 width="70">
                </el-table-column>
                <el-table-column prop="zhenduanfenxing"
                                 show-overflow-tooltip
                                 label="诊断分型">
                </el-table-column>
                <el-table-column show-overflow-tooltip
                                 prop="yiyuan"
                                 label="医院">
                </el-table-column>
                <el-table-column prop="created"
                                 label="录入时间"
                                 width="150">
                </el-table-column>
                <el-table-column prop="updated"
                                 label="修改时间"
                                 sortable="custom"
                                 width="150">
                </el-table-column>
                <el-table-column label="病例完成度"
                                 width="160"
                >
                    <template slot-scope="scope">
                        <el-tooltip class="item" content="基本信息模块未填写" placement="top" v-if="scope.row.jibenxinxi == 0">
                            <img src="../../assets/images/0.png" class="user-avatar"/>
                        </el-tooltip>
                        <el-tooltip class="item" content="基本信息模块已完整" placement="top"
                                    v-else-if="scope.row.jibenxinxi == 1">
                            <img src="../../assets/images/1.png" class="user-avatar "/>
                        </el-tooltip>
                        <el-tooltip class="item" content="基本信息模块已填写" placement="top" v-else>
                            <img src="../../assets/images/2.png" class="user-avatar "/>
                        </el-tooltip>
                        <el-tooltip class="item" content="临床信息模块未填写" placement="top"
                                    v-if="scope.row.linchuangxinxi == 0">
                            <img src="../../assets/images/0.png" class="user-avatar "/>
                        </el-tooltip>
                        <el-tooltip class="item" content="临床信息模块已完整" placement="top"
                                    v-else-if="scope.row.linchuangxinxi == 1">
                            <img src="../../assets/images/1.png" class="user-avatar "/>
                        </el-tooltip>
                        <el-tooltip class="item" content="临床信息模块已填写" placement="top" v-else>
                            <img src="../../assets/images/2.png" class="user-avatar "/>
                        </el-tooltip>
                        <el-tooltip class="item" content="细胞遗传模块未填写" placement="top" v-if="scope.row.xibaoyichuan == 0">
                            <img src="../../assets/images/0.png" class="user-avatar "/>
                        </el-tooltip>
                        <el-tooltip class="item" content="细胞遗传模块已完整" placement="top"
                                    v-else-if="scope.row.xibaoyichuan == 1">
                            <img src="../../assets/images/1.png" class="user-avatar "/>
                        </el-tooltip>
                        <el-tooltip class="item" content="细胞遗传模块已填写" placement="top" v-else>
                            <img src="../../assets/images/2.png" class="user-avatar "/>
                        </el-tooltip>
                        <el-tooltip class="item" content="分子标志模块未填写" placement="top" v-if="scope.row.fenzibiaozhi == 0">
                            <img src="../../assets/images/0.png" class="user-avatar "/>
                        </el-tooltip>
                        <el-tooltip class="item" content="分子标志模块已完整" placement="top"
                                    v-else-if="scope.row.fenzibiaozhi == 1">
                            <img src="../../assets/images/1.png" class="user-avatar "/>
                        </el-tooltip>
                        <el-tooltip class="item" content="分子标志模块已填写" placement="top" v-else>
                            <img src="../../assets/images/2.png" class="user-avatar "/>
                        </el-tooltip>
                        <el-tooltip class="item" content="免疫细胞模块未填写" placement="top"
                                    v-if="scope.row.mianyibiaoxing == 0">
                            <img src="../../assets/images/0.png" class="user-avatar "/>
                        </el-tooltip>
                        <el-tooltip class="item" content="免疫细胞模块已完整" placement="top"
                                    v-else-if="scope.row.mianyibiaoxing == 1">
                            <img src="../../assets/images/1.png" class="user-avatar "/>
                        </el-tooltip>
                        <el-tooltip class="item" content="免疫细胞模块已填写" placement="top" v-else>
                            <img src="../../assets/images/2.png" class="user-avatar "/>
                        </el-tooltip>
                        <el-tooltip class="item" content="治疗信息模块未填写" placement="top" v-if="scope.row.zhiliaoxinxi == 0">
                            <img src="../../assets/images/0.png" class="user-avatar "
                                 v-if="scope.row.zhiliaoxinxi == 0"/>
                        </el-tooltip>
                        <el-tooltip class="item" content="治疗信息模块已完整" placement="top"
                                    v-else-if="scope.row.zhiliaoxinxi == 1">
                            <img src="../../assets/images/1.png" class="user-avatar "/>
                        </el-tooltip>
                        <el-tooltip class="item" content="治疗信息模块已填写" placement="top" v-else>
                            <img src="../../assets/images/2.png" class="user-avatar "/>
                        </el-tooltip>
                        <el-tooltip class="item" content="转归费用模块未填写" placement="top"
                                    v-if="scope.row.zhuanguifeiyong == 0">
                            <img src="../../assets/images/0.png" class="user-avatar "/>
                        </el-tooltip>
                        <el-tooltip class="item" content="转归费用模块已完整" placement="top" v-else>
                            <img src="../../assets/images/1.png" class="user-avatar "/>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column label="未完成项"
                                 show-overflow-tooltip
                >
                    <template slot-scope="scope">
                        <span>{{ scope.row.weiwanchen | textfilter }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="备注" width="220"
                >
                    <template slot-scope="scope" class-name="tagss">
                        <div>
                            <el-tag style="width: inherit;border-color:inherit;cursor: pointer;"
                                    :key="index"
                                    type="warning"
                                    effect="plain"
                                    v-for="(tag,index) in scope.row.remarks"
                                    @click="handleUpdate(tag,index,scope.row.pk)">
                                {{tag}}
                            </el-tag>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="已整合共享数据" width="380" show-overflow-tooltip>
                    <template slot-scope="scope" class-name="tagss">
                        <div style="display: flex">
                            <el-tag style="width: inherit;border-color:inherit;margin: 0 3px"
                                    :key="index"
                                    :type="tag.indexOf('未') > -1?'info':'success'"
                                    v-for="(tag,index) in scope.row.tags">
                                <span v-if="tag.indexOf('已整合') > -1">
                                    <span v-if="tag.indexOf('未采纳') > -1">{{tag.replace('已整合:未采纳', '未采纳')}}</span>
                                    <span v-else>{{tag}}</span>
                                </span>
                                <span v-else>
                                    <span v-if="tag.indexOf('未采纳') > -1">{{tag.replace(':未采纳', '信息未采纳')}}</span>
                                    <span v-else>{{tag}}信息已整合</span>
                                </span>
                            </el-tag>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        fixed="right"
                        label="操作"
                        :width="is_admin?'220':'120' " v-if="groups != '3'">
                    <template slot-scope="scope">
                        <el-button @click="handleClick(scope.row)"
                                   size="small"
                                   type="text">详情
                        </el-button>
                        <el-button type="text" size="small" v-if="groups == '0'" @click="handleMode(scope.row)">
                            删除
                        </el-button>
                        <el-button @click="handleSet(scope.row)"
                                   size="small"
                                   type="text" v-if="is_admin">设置权限
                        </el-button>
                        <span v-if="groups != '0' || is_admin" style="margin-left: 10px">
                            <span v-show="groups == '1' || is_admin || groups == '2'">
                                <el-button @click="handleApprover(scope.row, '1')"
                                           v-if="scope.row.status == '0'||scope.row.status == '2'"
                                           type="text"
                                           style="color: #67c23a"
                                           size="small">通过
                                </el-button>
                            </span>
                            <span style="margin-left: 10px" v-show="groups == '1'|| is_admin || groups == '2'">
                                <el-button @click="handleApprover(scope.row, '5')"
                                           type="text"
                                           style="color: crimson"
                                           v-if="scope.row.status == '0' || scope.row.status == '2' "
                                           size="small">拒绝
                                </el-button>
                            </span>
                        </span>
                    </template>
                </el-table-column>
            </el-table>
            <div style="margin-top: 30px;text-align: center">
                <el-pagination :current-page="currentPage"
                               :page-size="pageSize"
                               :page-sizes="[10, 20, 30, 50, 100]"
                               :total="totalData"
                               @current-change="handleCurrentChange"
                               @size-change="handleSizeChange"
                               layout="total, sizes, prev, pager, next, jumper"></el-pagination>
            </div>
        </el-card>
        <el-dialog
                :title="quanxianDialogTitle"
                :visible.sync="model1"
                width="40%"
        >
            <p v-if="quanxianform.pk.length > 1" style="margin-left: 120px; color: #909399; margin-bottom: 12px;">
                已选择 {{ quanxianform.pk.length }} 位患者，设置后将覆盖所选患者的权限
            </p>
            <el-form :model="quanxianform" ref="quanxianform">
                <el-form-item label="用户" label-width="120px">
                    <el-select v-model="quanxianform.user" clearable multiple placeholder="请选择" style="width:80%"
                               filterable>
                        <el-option :label="item.label" :value="item.value" v-for="item in userList"
                                   :key="item.name"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="用户组" label-width="120px">
                    <el-select v-model="quanxianform.group" clearable multiple placeholder="请选择" style="width:80%"
                               filterable>
                        <el-option :label="item.label" :value="item.value" v-for="item in groupList"
                                   :key="item.name"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="model1 = false">取 消</el-button>
                <el-button type="primary" @click="handleQuanAdd">确 定</el-button>
              </span>
        </el-dialog>
        <el-dialog
                title="添加"
                :visible.sync="dialogVisible"
                width="40%"
        >
            <el-form :model="form" :rules="rules" ref="form">
                <el-form-item label="名称" label-width="120px" prop="name">
                    <el-input v-model="form.name" style="width:300px" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="handleAdd">确 定</el-button>
              </span>
        </el-dialog>
        <el-dialog
                title="删除"
                :visible.sync="model3"
                width="30%"
        >
            <span>您确定要删除吗？</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="model3 = false">取 消</el-button>
                <el-button type="primary" @click="handledel">确 定</el-button>
              </span>
        </el-dialog>
        <el-dialog
                title="详情"
                :visible.sync="models2"
                width="90%"
        >
            <Addmodel ref="addform" @childEvent="handleModel"/>
        </el-dialog>
        <el-dialog
                title="修改"
                :visible.sync="rkmodel"
                width="40%"
        >
            <el-form :model="formuprk" ref="formuprk">
                <el-form-item label="备注" label-width="120px">
                    <el-input v-model="formuprk.tag" style="width:300px" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="rkmodel = false">取 消</el-button>
                <el-button type="primary" @click="handleRk()">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog
                title="审核"
                :visible.sync="models3"
                width="40%"
        >
            <el-form :rules="rules" ref="formstatus">
                <div v-for="(item,index) in formstatus" :key="index" style="border-bottom: 1px solid #DCDFE6">
                    <el-form-item label="患者ID" label-width="120px">
                        <span>{{ item.pk }}</span>
                    </el-form-item>
                    <el-form-item label-width="120px" label="病例完成度">
                        <div>
                            <el-tooltip class="item" content="基本信息模块未填写" placement="top" v-if="item.jibenxinxi == 0">
                                <img src="../../assets/images/0.png" class="user-avatar"/>
                            </el-tooltip>
                            <el-tooltip class="item" content="基本信息模块已完整" placement="top"
                                        v-else-if="item.jibenxinxi == 1">
                                <img src="../../assets/images/1.png" class="user-avatar "/>
                            </el-tooltip>
                            <el-tooltip class="item" content="基本信息模块已填写" placement="top" v-else>
                                <img src="../../assets/images/2.png" class="user-avatar "/>
                            </el-tooltip>
                            <el-tooltip class="item" content="临床信息模块未填写" placement="top"
                                        v-if="item.linchuangxinxi == 0">
                                <img src="../../assets/images/0.png" class="user-avatar "/>
                            </el-tooltip>
                            <el-tooltip class="item" content="临床信息模块已完整" placement="top"
                                        v-else-if="item.linchuangxinxi == 1">
                                <img src="../../assets/images/1.png" class="user-avatar "/>
                            </el-tooltip>
                            <el-tooltip class="item" content="临床信息模块已填写" placement="top" v-else>
                                <img src="../../assets/images/2.png" class="user-avatar "/>
                            </el-tooltip>
                            <el-tooltip class="item" content="细胞遗传模块未填写" placement="top" v-if="item.xibaoyichuan == 0">
                                <img src="../../assets/images/0.png" class="user-avatar "/>
                            </el-tooltip>
                            <el-tooltip class="item" content="细胞遗传模块已完整" placement="top"
                                        v-else-if="item.xibaoyichuan == 1">
                                <img src="../../assets/images/1.png" class="user-avatar "/>
                            </el-tooltip>
                            <el-tooltip class="item" content="细胞遗传模块已填写" placement="top" v-else>
                                <img src="../../assets/images/2.png" class="user-avatar "/>
                            </el-tooltip>
                            <el-tooltip class="item" content="分子标志模块未填写" placement="top" v-if="item.fenzibiaozhi == 0">
                                <img src="../../assets/images/0.png" class="user-avatar "/>
                            </el-tooltip>
                            <el-tooltip class="item" content="分子标志模块已完整" placement="top"
                                        v-else-if="item.fenzibiaozhi == 1">
                                <img src="../../assets/images/1.png" class="user-avatar "/>
                            </el-tooltip>
                            <el-tooltip class="item" content="分子标志模块已填写" placement="top" v-else>
                                <img src="../../assets/images/2.png" class="user-avatar "/>
                            </el-tooltip>
                            <el-tooltip class="item" content="免疫细胞模块未填写" placement="top"
                                        v-if="item.mianyibiaoxing == 0">
                                <img src="../../assets/images/0.png" class="user-avatar "/>
                            </el-tooltip>
                            <el-tooltip class="item" content="免疫细胞模块已完整" placement="top"
                                        v-else-if="item.mianyibiaoxing == 1">
                                <img src="../../assets/images/1.png" class="user-avatar "/>
                            </el-tooltip>
                            <el-tooltip class="item" content="免疫细胞模块已填写" placement="top" v-else>
                                <img src="../../assets/images/2.png" class="user-avatar "/>
                            </el-tooltip>
                            <el-tooltip class="item" content="治疗信息模块未填写" placement="top" v-if="item.zhiliaoxinxi == 0">
                                <img src="../../assets/images/0.png" class="user-avatar "
                                     v-if="item.zhiliaoxinxi == 0"/>
                            </el-tooltip>
                            <el-tooltip class="item" content="治疗信息模块已完整" placement="top"
                                        v-else-if="item.zhiliaoxinxi == 1">
                                <img src="../../assets/images/1.png" class="user-avatar "/>
                            </el-tooltip>
                            <el-tooltip class="item" content="治疗信息模块已填写" placement="top" v-else>
                                <img src="../../assets/images/2.png" class="user-avatar "/>
                            </el-tooltip>
                            <el-tooltip class="item" content="转归费用模块未填写" placement="top"
                                        v-if="item.zhuanguifeiyong == 0">
                                <img src="../../assets/images/0.png" class="user-avatar "/>
                            </el-tooltip>
                            <el-tooltip class="item" content="转归费用模块已完整" placement="top" v-else>
                                <img src="../../assets/images/1.png" class="user-avatar "/>
                            </el-tooltip>
                        </div>
                    </el-form-item>
                    <el-form-item label="未完成项" label-width="120px">
                        <span>{{ item.weiwanchen | textfilter }}</span>
                    </el-form-item>
                    <el-form-item label="审核意见" label-width="120px">
                        <el-input v-model="item.opinion" style="width:80%" type="textarea"
                                  :disabled="groups=='1'?false:true || groups=='2'?false:true || groups=='4'?false:true"
                                  :autosize="{ minRows: 5, maxRows: 5}"></el-input>
                    </el-form-item>
                </div>
            </el-form>
            <span slot="footer" class="dialog-footer" v-if="groups !='3' && groups !='5'">
                <el-button @click="models3 = false">取 消</el-button>
                <el-button type="danger" @click="handleClickStatus('5')" v-if="batch">拒 绝</el-button>
                <el-button type="primary" @click="handleClickStatus('1')" v-if="batch">通 过</el-button>
                <el-button type="primary" @click="handleClickStatus()" v-if="!batch">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog
                title="申请下载"
                :visible.sync="applyModel"
                width="40%"
        >
            <div style="text-align: center">申请成功后，数据以邮件的方式发送到主任邮箱。</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="applyModel = false">取 消</el-button>
                <el-button type="primary" :disabled='but_disabled' @click="handleSend()">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import * as table from '../../config/cyit'
    import zhenduanfenxing_list from '../../config/zhenduanfenxing'
    import Addmodel from './add'
    import {setTimeout} from 'timers';

    export default {
        components: {
            Addmodel,
        },
        data() {
            return {
                visible: false,
                is_admin: false,
                groups: '0',
                models2: false,
                model1: false,
                models3: false,
                model3: false,
                rkmodel: false,
                applyModel: false,
                but_disabled: false,
                delpk: '',
                groupList: [],
                userList: [],
                quanxianDialogTitle: '设置权限',
                quanxianform: {
                    user: [],
                    group: [],
                    pk: [],
                },
                tag: '',
                setmodel: false,
                dynamicTags: [],
                inputVisible: false,
                inputValue: '',
                dialogVisible: false,
                loading: true,
                city: table.citys,
                minzu: table.minzu,
                zhuangtai: table.zhuangtai,
                sectionlist: table.sectionlist,
                mianyibiaoxing: table.mianyibiaoxing,
                xibaoyichuan: table.xibaoyichuan,
                linchuangxinxi: table.linchuangxinxi,
                zhenduanfenxing_list: zhenduanfenxing_list,
                zhiliaoxinxi: table.zhiliaoxinxi,
                jibenxinxi: table.jibenxinxi,
                zhuanguifeiyong: table.zhuanguifeiyong,
                fenzibiaozhi: table.fenzibiaozhi,
                currentPage: 1,
                pageSize: 20,
                totalData: 0,
                pk: 0,
                formstatus: [{
                    opinion: '',
                    status: null,
                    pk: null
                }],
                form: {
                    name: '',
                },
                formuprk: {
                    tag: "",
                    index: "",
                    pk: null
                },
                tableData: [],
                formInline: {
                    zhenduanfenxing: [],
                    daterange: [],
                    status: '',
                    powerAttrList: [{
                        symbol: '',
                        field: '',
                        value: '',
                        inputvalue: '',
                        condition: '',
                    }],
                },
                selectionList: [],
                status: '',
                batch: false,
                orderBys: [],
                sortField: [],
                options: [
                    {
                        value: '0',
                        label: '提交待审核'
                    }, {
                        value: '1',
                        label: '已通过审核'
                    }, {
                        value: '2',
                        label: '更新待审核'
                    },
                    {
                        value: '3',
                        label: '审核未通过(审核员)'
                    },
                    {
                        value: '4',
                        label: '未提交审核'
                    },
                    {
                        value: '5',
                        label: '审核未通过(审核管理员)'
                    },
                    {
                        value: '6',
                        label: '特殊未完成'
                    }, {
                        value: '7',
                        label: '已通过校对'
                    }],
                shfrom: {},
                senior: true,
                rules: {
                    name: [
                        {required: true, message: '请输入名称', trigger: 'blur'},
                    ]
                }
            }
        },
        filters: {
            textfilter(value) {
                if (!value) {
                    return
                }
                var temp = []
                var dictwwcx = {
                    "jibenxinxi": "基本信息",
                    "linchuangxinxi": "临床信息",
                    "xibaoyichuan": "细胞遗传",
                    "fenzibiaozhi": "分子标志",
                    "mianyibiaoxing": "免疫表型",
                    "zhiliaoxinxi": "治疗信息",
                }
                for (var i = 0; i < value.length; i++) {
                    temp.push(dictwwcx[value[i]])
                }
                if (temp.length) {
                    return temp.join("；")
                } else {
                    return ""
                }
            }
        },
        methods: {
            async handleSend() {
                try {
                    this.but_disabled = true
                    const resp = await this.$http.post("/case/applyDwonload/")
                    if (resp.data.code != '1') {
                        this.but_disabled = false
                        this.$message.error(resp.data.msg)
                    } else {
                        this.$message.success("申请成功！")
                        this.applyModel = false
                        this.but_disabled = false
                    }
                } catch (e) {
                    this.but_disabled = false
                    this.$message.error(e.message)
                }
            },
            async handleRk() {
                try {
                    const resp = await this.$http.post("/case/update/remarks/", this.formuprk)
                    if (resp.data.code != '1') {
                        this.$message.error(resp.data.msg)
                    } else {
                        this.$message.success("修改成功！")
                        this.rkmodel = false
                        this.search()
                    }
                } catch (e) {
                    this.$message.error(e.message)
                }
            },
            handleUpdate(tag, index, pk) {
                this.formuprk = {
                    tag: tag,
                    index: index,
                    pk: pk
                }
                this.rkmodel = true
            },
            handleHeadAddClass({column}) {
                if (this.sortField[column.property]) {
                    column.order = this.sortField[column.property]
                }
            },
            handleSortChange({order, prop}) {
                // 触发的排序和缓存的排序相同时，取消该字段的排序
                if (!order || this.sortField[prop] === order) {
                    this.sortField[prop] = null
                } else {
                    this.sortField[prop] = order
                }
                this.orderBys = []
                for (const i in this.sortField) {
                    if (this.sortField[i] == 'ascending') {
                        this.orderBys.push(i)
                    } else if (this.sortField[i] == 'descending') {
                        this.orderBys.push('-' + i)
                    }
                }
                this.search() //调用后端查询接口
            },
            checkboxT(row) {
                if (this.is_admin) {
                    return true
                }
                if (row.status == "0" || row.status == "2") {
                    return true
                } else {
                    return false
                }
            },
            parseQuanxian(value) {
                if (Array.isArray(value)) {
                    return value
                }
                if (!value) {
                    return []
                }
                try {
                    return JSON.parse(value)
                } catch (e) {
                    return []
                }
            },
            handelBatchQuan() {
                if (!this.is_admin) {
                    return
                }
                if (this.selectionList.length == 0) {
                    this.$message({
                        message: '请最少选择一个患者！',
                        type: 'warning'
                    })
                    return
                }
                this.quanxianDialogTitle = '批量设置权限'
                this.quanxianform.pk = this.selectionList.map(item => item.pk)
                this.quanxianform.user = []
                this.quanxianform.group = []
                this.model1 = true
            },
            handelBatch() {
                this.batch = true
                if (this.selectionList.length == 0) {
                    this.$message({
                        message: '请最少选择一个患者！',
                        type: 'warning'
                    })
                    return
                }
                this.models3 = true
            },
            handleSelectionChange(row) {
                var that = this
                that.formstatus = []
                that.selectionList = row
                row.forEach(function (item) {
                    var opinion = ''
                    if (!item.opinion) {
                        opinion = that.getdefault(item.weiwanchen)
                    } else {
                        opinion = item.opinion
                    }
                    item.opinion = opinion
                    that.formstatus.push(item)
                })
            },
            getdefault(value) {
                if (!value) {
                    return
                }
                var temp = ''
                var dictwwcx = {
                    "jibenxinxi": "基本信息未完整,请补充填写",
                    "linchuangxinxi": "临床信息未完整,请补充填写",
                    "xibaoyichuan": "细胞遗传未完整,请补充填写",
                    "fenzibiaozhi": "分子标志未完整,请补充填写",
                    "mianyibiaoxing": "免疫表型未完整,请补充填写",
                    "zhiliaoxinxi": "治疗信息未完整,请补充填写",
                }
                for (var i = 0; i < value.length; i++) {
                    temp += dictwwcx[value[i]] + "\n"
                }
                return temp
            },
            handleopinion(row) {
                this.$refs.multipleTable.clearSelection();
                this.formstatus = []
                this.formstatus.push(row)
                this.models3 = true
            },
            handleApprover(row, status) {
                this.$refs.multipleTable.clearSelection();
                row = JSON.stringify(row)
                row = JSON.parse(row)
                this.formstatus = []
                var opinion = ''
                if (!row.opinion) {
                    opinion = this.getdefault(row.weiwanchen)
                } else {
                    opinion = row.opinion
                }
                row.status = status
                row.opinion = opinion
                this.formstatus.push(row)
                this.models3 = true
            },
            handleMode(row) {
                this.delpk = row.pk
                this.model3 = true
            },
            handledel() {
                this.$http.post(`/case/del/${this.delpk}/`)
                    .then(resp => {
                            if (resp.data.code == 1) {
                                this.$message({
                                    message: '提交成功！',
                                    type: 'success'
                                })
                                this.model3 = false
                                this.search()
                            } else {
                                this.$message({
                                    message: resp.data.msg,
                                    type: 'error'
                                })
                            }
                        }
                    )
            },
            handleClickStatus(status) {
                var data = []
                var that = this
                this.formstatus.forEach(function (items) {
                    if (!that.batch) {
                        status = items.status
                    }
                    data.push({
                        pk: items.pk,
                        status: status,
                        opinion: items.opinion
                    })
                })
                this.$http.post(`/case/status/`, data)
                    .then(resp => {
                            if (resp.data.code == 1) {
                                this.$message({
                                    message: '提交成功！',
                                    type: 'success'
                                })
                                this.models3 = false
                                this.search()
                            } else {
                                this.$message({
                                    message: resp.data.msg,
                                    type: 'error'
                                })
                            }
                        }
                    )
            },
            handlepk(row) {
                if (this.groups != '3') {
                    this.models2 = true
                    setTimeout(function () {
                        this.$refs.addform.getData(row.pk, 'edit')
                    }.bind(this), 400)
                }
            },
            handleQuanAdd() {
                if (!this.is_admin) {
                    this.$message({
                        message: '仅管理员可配置权限',
                        type: 'warning'
                    })
                    return
                }
                this.$http.post('/case/jurisdiction/', this.quanxianform)
                    .then(resp => {
                        if (resp.data.code == '1' || resp.data.code == 1) {
                            this.$message({
                                message: '设置成功！',
                                type: 'success'
                            })
                            this.model1 = false
                            this.search()
                        } else {
                            this.$message({
                                message: resp.data.msg || '设置失败',
                                type: 'error'
                            })
                        }

                    })
                    .catch((err) => {
                        console.log(err)
                        this.loading = false
                    })
            },
            handClick(pk) {
                if (pk) {
                    this.pk = pk
                } else {
                    pk = this.pk
                }
                this.setmodel = true
                this.$http.post(`/case/aggregate/${pk}/?page=${this.currentPage}&pageSize=${this.pageSize}`)
                    .then(resp => {
                        if (resp.data.code == '1') {
                            this.tableData = resp.data.data
                            this.totalData = resp.data.total
                            this.loading = false
                        }

                    })
                    .catch((err) => {
                        console.log(err)
                        this.loading = false
                    })
            },
            handleSet(row) {
                if (!this.is_admin) {
                    return
                }
                this.quanxianDialogTitle = '设置权限'
                this.model1 = true
                this.quanxianform.pk = [row.pk]
                this.quanxianform.user = this.parseQuanxian(row.userquanxian)
                this.quanxianform.group = this.parseQuanxian(row.groupquanxian)
            },
            handleClose(pk) {
                this.$http.post('/case/aggregate/del/', {'pk': pk})
                    .then(resp => {
                        if (resp.data.code == 1) {
                            this.dialogVisible = false
                            this.$message({
                                message: '删除成功！',
                                type: 'success'
                            })
                            this.getAggregate()
                        }
                    })
                    .catch((err) => {
                        console.log(err)
                        this.loading = false
                    })
            },
            handleAdd() {
                this.tag = ''
                this.formInline['page'] = this.currentPage
                this.formInline['pageSize'] = this.pageSize
                this.formInline['keywords'] = (this.formInline.zhenduanfenxing.length == 2 ? this.formInline.zhenduanfenxing[1] : this.formInline.zhenduanfenxing[0]) || ''
                this.formInline['start'] = this.formInline.daterange[0] || ''
                this.formInline['end'] = this.formInline.daterange[1] || ''
                this.formInline['name'] = this.form.name
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        this.$http.post('/case/aggregate/add/', this.formInline)
                            .then(resp => {
                                if (resp.data.code == '1') {
                                    this.dialogVisible = false
                                    this.$message({
                                        message: '提交成功！',
                                        type: 'success'
                                    })
                                    this.getAggregate()
                                }
                            })
                            .catch((err) => {
                                console.log(err)
                                this.loading = false
                            })
                    }
                })
            },
            handleValue(index) {
                this.formInline.powerAttrList[index].value = ''
            },
            hLower() {
                this.senior = !this.senior;
                this.onReset();
            },
            addRow() {
                this.formInline.powerAttrList.push({
                    symbol: '',
                    field: '',
                    value: '',
                    inputvalue: '',
                    condition: '',
                });
            },
            removeRow(index) {
                this.formInline.powerAttrList.splice(index, 1);
            },
            bingli(row) {
                if (row.bingli) {
                    return '复发'
                } else {
                    return '初发'
                }
            },
            onSubmit() {
                if (this.senior) {
                    this.$refs['formInline'].validate((valid) => {
                        if (valid) {
                            this.search()
                        }
                    })
                } else {
                    this.search()
                }
            },
            onReset() {
                this.$router.replace({path: "/rms/archives"});
                this.setmodel = false
                this.status = ''
                this.tag = ''
                this.$refs['formInline'].resetFields()
                this.formInline.powerAttrList = [{
                    symbol: '',
                    field: '',
                    value: '',
                    inputvalue: '',
                    condition: '',
                }]
                this.formInline.zhenduanfenxing = []
                this.formInline.daterange = []
                this.formInline.status = ''
                this.currentPage = 1
                this.search()
            },
            handleClick(row) {
                let routeUrl = this.$router.resolve({
                    path: "/rms/registration/" + row.pk,
                });
                window.open(routeUrl.href, '_blank');
                // this.$router.push({
                //   path: '/rms/registration/' + row.pk,
                // })
            },
            handleSizeChange(val) {
                this.currentPage = 1
                this.pageSize = val
                if (this.setmodel) {
                    this.handClick()
                } else {
                    this.search()
                }
            },
            handleCurrentChange(val) {
                // console.log(`当前页: ${val}`)
                this.currentPage = val
                if (this.setmodel) {
                    this.handClick()
                } else {
                    this.search()
                }
            },
            search() {
                this.loading = true
                this.setmodel = false
                this.tag = ''
                const name = this.$route.query.name
                if (name) {
                    if (this.formInline.powerAttrList.length == 1 && !this.formInline.powerAttrList[0].field) {
                        this.formInline.powerAttrList = []
                    }
                    if (name != "待随访") {
                        const exists = this.formInline.powerAttrList.some(item => item.field === 'status_tag' && item.value === name);
                        if (!exists) { // 如果不存在，则添加新对象
                            this.formInline.powerAttrList.push({
                                symbol: '',
                                field: 'status_tag',
                                value: name,
                                inputvalue: '',
                                condition: '',
                            });
                        }
                    } else {
                        const nameMapping = {
                            '待随访': ['待随访（第一批）', '待随访（第一批）*', '待随访（第二批）']
                        };
                        const toAddList = nameMapping[name] || [name]; // 如果没有特定映射，则使用name本身
                        toAddList.forEach(value => {
                            const exists = this.formInline.powerAttrList.some(item => item.field === 'status_tag' && item.value === value);
                            if (!exists) {
                                // 如果不存在，则添加新对象
                                this.formInline.powerAttrList.push({
                                    symbol: '',
                                    field: 'status_tag',
                                    value: value,
                                    inputvalue: '',
                                    condition: 'OR',
                                });
                            }
                        });
                    }
                }
                const type = this.$route.query.type;
                this.formInline['orderBys'] = this.orderBys
                this.formInline['type'] = type
                this.formInline['page'] = this.currentPage
                this.formInline['pageSize'] = this.pageSize
                this.formInline['keywords'] = (this.formInline.zhenduanfenxing.length == 2 ? this.formInline.zhenduanfenxing[1] : this.formInline.zhenduanfenxing[0]) || ''
                this.formInline['start'] = this.formInline.daterange[0] || ''
                this.formInline['end'] = this.formInline.daterange[1] || ''
                this.$http.post('/case/search/list/', this.formInline)
                    .then(resp => {
                        this.tableData = resp.data.data
                        this.totalData = resp.data.total
                        this.loading = false
                    })
                    .catch((err) => {
                        console.log(err)
                        this.loading = false
                    })
            },
            getUser() {
                this.$http.get(`/auth/list/`)
                    .then(resp => {
                        this.userList = resp.data.data
                    })
                    .catch((err) => {
                        console.log(err)
                    })
            },
            getGroup() {
                this.$http.get(`/auth/group/list/`)
                    .then(resp => {
                        this.groupList = resp.data.data
                    })
                    .catch((err) => {
                        console.log(err)
                    })
            },
            getAggregate() {
                this.$http.get(`/case/aggregate/`)
                    .then(resp => {
                        this.dynamicTags = resp.data.data
                    })
                    .catch((err) => {
                        console.log(err)
                    })
            },
            getData() {
                var that = this
                this.loading = true
                this.setmodel = false
                this.tag = ''
                var gengxin = this.$route.query.data || ''
                setTimeout(function () {
                    var keywords = (this.formInline.zhenduanfenxing.length == 2 ? this.formInline.zhenduanfenxing[1] : this.formInline.zhenduanfenxing[0]) || ''
                    var start = this.formInline.daterange[0] || ''
                    var end = this.formInline.daterange[1] || ''
                    this.$http.get(`/case/list/?page=${this.currentPage}&pageSize=${this.pageSize}&keywords=${keywords}&start=${start}&end=${end}&gengxin=${gengxin}&status=${that.status}`)
                        .then(resp => {
                            this.tableData = resp.data.data
                            this.totalData = resp.data.total
                            this.loading = false
                        })
                        .catch((err) => {
                            console.log(err)
                            this.loading = false
                        })
                }.bind(this), 400)
            },
            handleModel() {
                var that = this
                setTimeout(function () {
                    that.models2 = false
                }, 2000)
            }
        },
        mounted() {
            let is_admin = localStorage.getItem('is_admin')
            this.groups = localStorage.getItem('groups')
            this.is_admin = is_admin === 'true' || is_admin === true
            if (this.is_admin) {
                this.getUser()
                this.getGroup()
            }
            this.getAggregate()
            this.search()
        }
    };
</script>
<style>
    /* 全局样式文件或组件的<style>标签 */
    .custom-tooltip-background {
        background-color: white !important; /* 使用!important确保覆盖默认样式 */
        border: 1px solid #67c23a;
    }
</style>

<style scoped>
    /deep/ .dynamicTags .el-radio__input {
        display: none;
    }

    /deep/ .el-radio__label {
        font-size: 14px;
        padding-left: 5px;
    }

    .el-radio {
        margin-right: 0px;
    }

    .el-tag + .el-tag {
        display: table;
        /*margin-left: 10px;*/
    }

    .el-tag--mini {
        height: 28px;
        padding: 0 10px;
        line-height: 27px;

    }

    .button-new-tag {
        margin-left: 10px;
        height: 32px;
        line-height: 30px;
        padding-top: 0;
        padding-bottom: 0;
    }

    .input-new-tag {
        width: 90px;
        margin-left: 10px;
        vertical-align: bottom;
    }

    /*.xiala /deep/ .el-input--mini .el-input__inner {
      width: 500px;
    }*/
    .primary {
        background-color: #909399;
        border-color: #909399;
        color: white;
    }

    .info {
        background-color: #e4e4e4;
        border-color: #e4e4e4;
        color: #909399;
    }

    .infos {
        background-color: #67c23a;
        /*border-color: #e4e4e4;*/
        color: white;
    }

    #warning {
        display: inline-block;
        background: #e6a23c;
        color: white;
    }

    .warning {
        display: inline-block;
        background: #e6a23c;
        color: white;
    }

    .red {
        display: inline-block;
        background: #f56c6c;
        color: white;
    }

    .table /deep/ .el-tag--mini {
        width: 88%;
        height: 20px;
        padding: 0 5px;
        line-height: 19px;
        text-align: center;
        border-color: transparent;
    }

    .demo-form-inline {
        text-align: center;
    }

    .demo-form {
        /*margin-left: 30px;*/
        width: 100%;
    }

    .demo-form /deep/ .el-form-item.is-success .el-input__inner {
        border-color: none;
    }

    .demo-form /deep/ .el-input--medium .el-input__inner {
        height: 25px;
        line-height: 25px;
    }

    .demo-form /deep/ .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item {
        margin-bottom: 8px;
    }

    .user-avatar {
        width: 20px;
        height: 20px;
        /*border-radius: 10px;*/
        vertical-align: middle;
    }

    .circle {
        margin-right: 10px;
        width: 8px; /* 圆点的宽度 */
        height: 8px; /* 圆点的高度 */
        background-color: #67c23a; /* 圆点的颜色 */
        border-radius: 50%; /* 将边角圆化，生成圆形 */
        display: inline-block; /* 使div以内联块的方式显示 */
    }

</style>
